const isSafeKey = (key) => {
  return !['__proto__', 'constructor', 'prototype'].includes(key);
};
const isCounter = (value) => {
  return typeof value === 'number' && Number.isFinite(value);
};

// POST /candidate: arrays, countOfOrphanedRows, and emptyCellSummary
// { mode: 'keep' | 'erase', fieldsKept, fieldsErased }. Never retain unknown
// metadata values: they may contain applicant data. Diagnostics contain types only.
export const aggregateCandidateImportResults = (previous, data) => {
  const results = { ...previous };
  const diagnostics = [];
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return { results, diagnostics: [{ reason: 'invalid-response' }] };
  }
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (!isSafeKey(key)) {
      diagnostics.push({ reason: 'unsafe-key' });
      return;
    }
    const prior = Object.prototype.hasOwnProperty.call(results, key) ? results[key] : undefined;
    if (Array.isArray(value) && (prior === undefined || Array.isArray(prior))) {
      results[key] = [...(prior || []), ...value];
    } else if (isCounter(value) && (prior === undefined || isCounter(prior))) {
      results[key] = (prior || 0) + value;
    } else if (key === 'emptyCellSummary' && value && typeof value === 'object' && !Array.isArray(value)) {
      const summary = { ...(prior || {}) };
      ['fieldsKept', 'fieldsErased'].forEach((counter) => {
        if (value[counter] === undefined) {
          return;
        }
        if (Object.prototype.hasOwnProperty.call(value, counter) && isCounter(value[counter])) {
          summary[counter] = (isCounter(summary[counter]) ? summary[counter] : 0) + value[counter];
        } else {
          diagnostics.push({ reason: 'invalid-summary-counter' });
        }
      });
      if (Object.prototype.hasOwnProperty.call(value, 'mode') && ['keep', 'erase'].includes(value.mode)) {
        if (summary.mode && summary.mode !== value.mode) {
          diagnostics.push({ reason: 'inconsistent-summary-mode' });
        } else {
          summary.mode = value.mode;
        }
      }
      results[key] = summary;
    } else if (value !== undefined) {
      diagnostics.push({ reason: 'unsupported-response-type', type: typeof value });
    }
  });
  return { results, diagnostics };
};

// The rejection handler belongs to the request, not the success processor.
// A saved batch must never become a failed batch because client processing threw.
export const processCandidateImportBatch = async ({ request, onSuccess, onFailure, onClientError }) => {
  let response;
  try {
    response = await request();
  } catch (error) {
    onFailure(error);
    return;
  }
  try {
    onSuccess(response);
  } catch (error) {
    onClientError();
  }
};
